import { StaticImageData } from 'next/image';

import type { FTFLinkType, FTFSocialLinkType } from '~/types/product';
import FacebookIcon from '~/public/brands/facebook-circle.png';
import YoutubeIcon from '~/public/brands/youtube-logo.png';
import XIcon from '~/public/brands/x-logo.png';
import LinkedInIcon from '~/public/brands/linkedin-icon.png';
import TiktokIcon from '~/public/brands/tiktok-icon.png';

export enum UserStaffMessageGroupTypes {
  ALL = 'all',
  PAID = 'paid',
  PAID_PLUS = 'paid_plus',
  PAID_NON_PLUS = 'paid_non_plus',
}
export enum UserStaffMessageLocations {
  TOP = 'top',
  MID = 'mid',
}

export const FOMO_QUANTITY_REMAINING = 200;

export enum FeatureType {
  STRING = 0,
  BOOLEAN = 1,
  NUMBER = 2,
}

export const PRICING_CELL_STYLE =
  'w-1/5 max-w-[1/5] border border-sundog p-4 font-medium text-midnight';

/** Max amount of helpful links to display in the new FTF section on PDP. */
export const FTF_MAX_LINKS_TO_DISPLAY = 5;

export const FTF_SOCIAL_LINK_TYPES: FTFLinkType[] = [
  'facebook',
  'youtube',
  'twitter',
  'linkedin',
  'tiktok',
];

export const SOCIAL_LINKS_CONFIG: Record<
  FTFSocialLinkType,
  { icon: StaticImageData }
> = {
  facebook: { icon: FacebookIcon },
  youtube: { icon: YoutubeIcon },
  twitter: { icon: XIcon },
  linkedin: { icon: LinkedInIcon },
  tiktok: { icon: TiktokIcon },
};

/** Max amount of posts to display in the new FTF section on PDP. */
export const FTF_MAX_POSTS_TO_DISPLAY = 5;

/** Prefix for the FTF post hash. */
export const FTF_POST_NUMBER_HASH_PREFIX = 'founder-post-';
